<footer class="footer--container">
    <section class="footer--wrapper">
        <div class="footer--logo">
            <a routerLink="/">
                <img alt="footer-logo" src="assets/images/logo@2x-light.png" />
                <span>ACTIVATE OPPORTUNITIES</span>
            </a>
        </div>
        <div class="footer--menu">
            <ul class="menu">
                <li><a routerLink="/">{{language.fmenu1}}</a></li>
                <li><a [routerLink]="['/compliance-good-governence','option1']">{{language.fmenu2}}</a></li>
                <li><a routerLink="/fund">{{language.fmenu3}}</a></li>
                <li><a [routerLink]="['/compliance-index-manager','option1']">{{language.fmenu4}}</a></li>
                <li><a [routerLink]="['/calculate']">{{language.fmenu5}}</a></li>
                <li><a routerLink="/fund-service-unit">{{language.fmenu6}}</a></li>
                <li><a routerLink="/private-fund">{{language.fmenu7}}</a></li>
                <li><a routerLink="/th/News">{{language.fmenu8}}</a></li>
                <li><a routerLink="/provident-fund">{{language.fmenu9}}</a></li>
                <li><a [routerLink]="['/Promotion','promo']">{{language.fmenu10}}</a></li>
                <li><a routerLink="/Calendar">{{language.fmenu11}}</a></li>
                <li><a routerLink="/Faq">{{language.fmenu12}}</a></li>
                <li><a routerLink="/Sitemap2">{{language.fmenu13}}</a></li>
                <li><a routerLink="/job-list">{{language.fmenu14}}</a></li>
                <li><a routerLink="/contact-us">{{language.fmenu15}}</a></li>
                <li><a routerLink="/privacy-notice">{{language.fmenu16}}</a></li>
                <li><a routerLink="/oneam-privacy-notice">{{language.fmenu17}}</a></li>
                
            </ul>
            <div class="social--list">
                <a href="https://www.facebook.com/OneAssetManagement/" class="social--item fb">
                    <i class="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.youtube.com/channel/UCRjeEzdqA-S-0AkMIka1gvg" class="social--item youtube">
                    <i class="fab fa-youtube"></i>
                </a>
                <a href="http://line.me/ti/p/%40oil6565f" class="social--item line">
                    <i class="fab fa-line"></i>
                </a>
                <a href="mailto:marketing@one-asset.com" class="social--item">
                    <i class="fas fa-envelope"></i>
                </a>
            </div>
            <div class="cer">
                <img src="../../../assets/images/ตรา Certified.png" class="cer_img" >
            </div>
        </div>
        <div class="footer--bottom">
            <div class="information">
                <span>{{language.f_title}}</span>
                <span class="copyright">© 2017 One Asset Management Limited. All Rights Reserved</span>
            </div>
            <div class="telephone">
                <span class="icon"><i class="fas fa-phone"></i></span>
                <span class="number"> 0-2659-8888</span>
            </div>
        </div>

    </section>
</footer>